module.exports = __webpack_public_path__ + "img/img-today-total.c8c6afe1.png";